import {ReactNode} from 'react';
import {PlatformLoader} from '@flexinet/ui-components';
import {useAuth} from "../hooks/useAuth.ts";
import {RedirectToSignIn} from "../components/RedirectToSignIn.tsx";

// Reads `status`, never `user`: `user` is undefined while getCurrentUser() is
// still pending, and redirecting then would bounce every reload out to sign in
// (the FNP-1416 shape, fixed the same way in the console under FNP-1718).
//
// FNP-1708: an anonymous visitor signs in at the login app, through the broker.
// Sign-up is the login app's too, along with its registration pause (FNP-1222).
export const RequireAuth = ({children}: { children: ReactNode }) => {
    const {status} = useAuth();

    if (status === 'resolving') {
        return <PlatformLoader message='Signing in...'/>;
    }

    if (status === 'anonymous') {
        return <RedirectToSignIn/>;
    }

    return children;
};
